// extracted by mini-css-extract-plugin
export var breadcrumb = "layout-module--breadcrumb--273d5";
export var page = "layout-module--page--383c2";
export var separator = "layout-module--separator--baab1";
export var wrapper = "layout-module--wrapper--5ec98";